import React, { Component } from 'react'
import history from "../History/history";
import { Route, Switch, Router } from "react-router-dom";
import Join from '../../Components/Join/join';
import Chat from '../../Components/Chat/chat';
class routing extends Component {
    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={props => <Join {...props} />}
                    />
                    <Route
                        path="/chat"
                        render={props => <Chat {...props} />}
                    />
                </Switch>
            </Router>
        )
    }
}
export default routing;